import React from 'react'
import { Button, Popover } from 'antd';
import BotForm from '../botForm/BotForm';

type NewBotButtonProps = {}

export const NewBotButton: React.FunctionComponent<NewBotButtonProps> = props => {
    return <Popover
    content={<BotForm/>}
    trigger="click"
  >
    <Button>Créer un agent conversationnel</Button>
  </Popover>
}

export default NewBotButton
